var _circle, _circle2, _circle3, _circle4, _circle5, _rect, _path, _circle6, _circle7, _circle8, _circle9, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessfulTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 133,
    viewBox: "0 0 137 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.3426,
    cy: 66.6824,
    r: 51.9461,
    fill: "#00E194"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.473,
    cy: 20.2625,
    r: 5.52618,
    fill: "#00E194"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7374,
    cy: 7.36824,
    r: 7.36824,
    fill: "#00E194"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.36771,
    cy: 97.9976,
    r: 3.68412,
    fill: "#00E194"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.944,
    cy: 118.26,
    r: 1.84206,
    fill: "#00E194"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43.4726,
    height: 43.4726,
    transform: "translate(48.6055 44.9463)",
    fill: "#00E194"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4989 48.5684H78.2034C84.3439 48.5684 88.4557 52.8794 88.4557 59.2916V74.0922C88.4557 80.4845 84.3439 84.7955 78.2034 84.7955H62.4989C56.3584 84.7955 52.2285 80.4845 52.2285 74.0922V59.2916C52.2285 52.8794 56.3584 48.5684 62.4989 48.5684ZM69.3092 72.0976L77.9132 63.4936C78.529 62.8778 78.529 61.8815 77.9132 61.2475C77.2973 60.6317 76.2829 60.6317 75.6671 61.2475L68.1862 68.7284L65.0163 65.5586C64.4004 64.9427 63.3861 64.9427 62.7702 65.5586C62.1543 66.1744 62.1543 67.1707 62.7702 67.8047L67.0812 72.0976C67.3892 72.4055 67.7877 72.5504 68.1862 72.5504C68.6028 72.5504 69.0013 72.4055 69.3092 72.0976Z",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.471,
    cy: 3.31569,
    r: 1.84206,
    fill: "#00E194"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0515,
    cy: 130.05,
    r: 2.57888,
    fill: "#00E194"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.8931,
    cy: 125.997,
    r: 0.736824,
    fill: "#00E194"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.629,
    cy: 81.4192,
    r: 1.84206,
    fill: "#00E194"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.736824,
    cy: 55.2622,
    r: 0.736824,
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulTransaction);
export default __webpack_public_path__ + "static/media/successfulTransaction.effaebd36d0a21d5421d8715db8d6710.svg";
export { ForwardRef as ReactComponent };